export const ROUTES = {
  CALLBACK: "/callback",
  DASHBOARD: "/dashboard",
  PROFILE_SETTINGS: "/profile-settings",
  MFA: "/profile-settings/mfa",
  UPDATE_PHONE: "/profile-settings/update-phone",
  USER_MANAGEMENT: "/user-management",
} as const;

export const ROUTE_TITLES: Partial<Record<string, string>> = {
  [ROUTES.MFA]: "Lucid Motors - Manage MFA",
  [ROUTES.UPDATE_PHONE]: "Lucid Motors - Manage Phone Number",
  [ROUTES.PROFILE_SETTINGS]: "Lucid Motors - Manage Profile",
  [ROUTES.DASHBOARD]: "Dashboard",
  [ROUTES.USER_MANAGEMENT]: "User Management",
};
